export function companyCourierGeolocation({ params }) {
  return {
    url: `/api/company_couriers/${params.id}/request_geolocation`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}

export function companyCourierHour({ params, body }) {
  return {
    url: `/api/company_couriers/${params.id}/hour`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(body),
  }
}

export function toggleDeclaredTime({ params }) {
  return {
    url: `/api/company_courier_hours/${params.id}/declared_times/${params.declaredTimeId}/toggle`,
    method: 'PATCH',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
  }
}
